import React from "react";
import "./CheckBox.css";

type Props = {
  id: string;
  name: string;
  checked: boolean;
  onChange: (id: string, checked: boolean) => void;
  label?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  colorVariant?: "default" | "alternate";
  children?: React.ReactNode;
  size?: "small" | "medium" | "large";
};
export default function CheckBox({
  id,
  name,
  checked,
  onChange,
  label,
  style,
  disabled = false,
  colorVariant = "default",
  children,
  size = "medium"
}: Props) {
  return (
    <label
      className={
        disabled
          ? "cb-container cb-container-disabled " + colorVariant
          : "cb-container " + colorVariant
      }
      id={id}
      style={{ ...style }}
    >
      {label}
      {children}
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={(e) => onChange(id, !checked)}
        disabled={disabled}
      />
      <span className={`cb-checkmark cb-${size}`} />
    </label>
  );
}
